"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.redux_store = void 0;
//DON'T USE THIS WAY OF ACCESSING THE STORE WITH SERVER-SIDE RENDERING!
//HOWEVER, IT"S FINE FOR US.
const toolkit_1 = require("@reduxjs/toolkit");
const reducers_1 = require("./reducers/reducers");
const local_storage_names_1 = require("./constants/local_storage_names");
//Create our redux store, and connect to the devtools. :)
//The key here is to export the store.
const enable = process.env.ENABLE_REDUX_DEVTOOLS;
// Preload user state from localStorage (fixes 403 errors on page load)
function loadUserStateFromLocalStorage() {
    var _a;
    try {
        const userLocalStorage = localStorage.getItem(local_storage_names_1.USER_LOCAL_STORAGE);
        if (userLocalStorage) {
            const authData = JSON.parse(userLocalStorage);
            console.log("🔧 Preloading Redux with token from localStorage:", authData.token ? "Token found" : "No token");
            // Simplified FaceTec architecture (PR #40):
            // If user has valid token, they've already passed FaceTec auth at login
            // JWT token is now sufficient for all operations
            const hasFaceTecAuth = !!authData.token && !!((_a = authData.user) === null || _a === void 0 ? void 0 : _a._id);
            // IMPORTANT: Don't trust permissions from localStorage - they may be stale
            // Permissions are synced from Firebase on each login/refresh
            // Clear permissions to force fresh check (UserRefreshInitializer will update them)
            const userWithoutCachedPermissions = Object.assign(Object.assign({}, (authData.user || {})), { permissions: {} });
            const preloadedState = {
                userState: {
                    user: userWithoutCachedPermissions,
                    token: authData.token || "",
                    isLoading: false,
                    newRegistration: false,
                    faceTecAuthorized: hasFaceTecAuth,
                    faceTecSessions: {
                        view: null,
                        edit: null,
                    },
                    faceTecSession: null,
                    accessAuth: null,
                },
            };
            return preloadedState;
        }
    }
    catch (error) {
        console.error("Failed to load user state from localStorage:", error);
    }
    return undefined;
}
const preloadedState = loadUserStateFromLocalStorage();
exports.redux_store = (0, toolkit_1.configureStore)({
    devTools: enable == "true"
        ? {
            // Prevent circular reference errors in DevTools
            serialize: {
                options: {
                    map: true,
                    set: true,
                },
                replacer: (key, value) => {
                    // Skip circular references and React internals
                    if (value && typeof value === "object") {
                        if (value._context || value.Provider || value.Consumer) {
                            return "[React Context]";
                        }
                    }
                    return value;
                },
            },
            maxAge: 50, // Limit action history to prevent memory issues
        }
        : false,
    reducer: reducers_1.reducers,
    preloadedState: preloadedState,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        // This was here because we had onClick's in our objects.
        // Now we have the onClick's in our components - this warning would be valid.
        serializableCheck: false,
    }),
});
